import React, { useState, useEffect } from "react";
import Skeleton from "@mui/material/Skeleton";
import SearchButton from "../SelectValue/SearchButton";
import RentalListCom from "./RentalListCom";
import getServices from "../../Services/get-service";
import Note from "../../Assets/images/note.svg";
import { toast } from "react-toastify";

function RentalList() {
  const [rentals, setRentals] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getServices
      .getRentals()
      .then((response) => {
        setLoading(false);
        if (response.data.statusCode === 200) {
          const rentalsData = response.data.data?.projects || [];
          setRentals(Array.isArray(rentalsData) ? rentalsData : []);
        } else {
          console.log(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        toast.error(error?.response?.data?.description, {
          autoClose: 1000,
        });
      });
  }, []);

  const filteredRentals = rentals.filter((rental) => {
    const searchStr = searchTerm.toLowerCase();
    const titleMatch = rental.title?.toLowerCase().includes(searchStr);
    const idMatch = String(rental.id).toLowerCase().includes(searchStr);
    return titleMatch || idMatch;
  });

  return (
    <div className=" mt-3 p-2">
      <SearchButton value={searchTerm} onChange={setSearchTerm} />
      <div className=" pt-4">
        {loading ? (
          <>
            {[1, 2, 3, 4].map((item) => (
              <div
                key={item}
                className=" grid my-3 grid-cols-3 border-gray-200 border rounded-lg overflow-hidden"
              >
                <Skeleton variant="rectangular" height="100%" width="100%" />
                <div className=" px-3 py-2 col-span-2">
                  <div className=" mb-2 flex justify-between">
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="20%" height={24} />
                  </div>
                  <div className=" mb-1 flex justify-between arrow-center">
                    <Skeleton variant="text" width="40%" height={24} />
                    <Skeleton variant="text" width="30%" height={24} />
                  </div>
                  <div className=" mb-2">
                    <Skeleton variant="text" width="80%" height={24} />
                  </div>
                  <div>
                    <Skeleton
                      variant="rectangular"
                      width={120}
                      height={36}
                      sx={{ borderRadius: 1 }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : filteredRentals.length < 1 ? (
          <div className="flex flex-col items-center justify-center py-10">
            <img src={Note} alt="No rentals" className="mb-4 w-16 h-16" />
            <p className="text-center text-gray-500 font-medium">
              No property found.
            </p>
            <p className="text-center text-gray-500">
              Try searching with a different name or ID
            </p>
          </div>
        ) : (
          filteredRentals.map((rental, i) => (
            <RentalListCom key={i} rental={rental} />
          ))
        )}
      </div>
    </div>
  );
}

export default RentalList;
